var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.admin)?_c('UserCard',{attrs:{"name":_vm.name,"email":_vm.admin.email,"info":_vm.admin.organization,"background":true,"image":_vm.admin.avatar,"to":{name: 'settings-admin', params: {id: _vm.admin.id}}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }